import {
	DepartmentKey,
	Departments,
} from '@shared/utils/constants';

export const getDepartmentLabel = (departmentKey: DepartmentKey): string => (
	Object.values(Departments).find(({ key }: { key: DepartmentKey }) => key === departmentKey)?.name ?? ''
);
